import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { ComponentBase, DbaDataTableColumn, DbaMAtTableDatatypesEnum, DialogData, Mandant, MandantAuthService } from '@definitiv-packages/angular-dba-library';

import { SafetypointPDFService, ProjectLanguage, ProjektPermissionService, RoofareaModel, SafetyPointModel, SafetyPointModelView, SafetyPointService, SafetyPointViewService, SicherungssystemModel, SicherungssystemModelView, SicherungssystemViewService, SafetyPointFormModelViewService, DebitorModel, DebitorService, StandortModel, StandortService, ObjektModelView, ObjektViewService, RoofareaModelView, RoofareaViewService, DocumentDataType } from '../../../../../roofsafetymanagement-library/src/public-api';
import { CreateSafetyPointComponent } from '../../../../../roofsafetymanagement-library/src/lib/dialogs/create-safetypoint/create-safetypoint.component';
import { SafetyPointFormComponent } from '../../dialogs/safetypointform-dialog/safetypointform-dialog.component';
import { DocumentService } from '@definitiv-packages/angular-documents-library';
import { CompletedFormDto, CompletedFormDtoService, FormDtoService, FormViewService } from '@definitiv-packages/angular-forms-library';

@Component({
  selector: 'app-safetypoint-main-view',
  templateUrl: './safetypoint-main-view.component.html',
  styleUrls: ['./safetypoint-main-view.component.scss'],
  standalone: false
})
export class SafetyPointMainViewComponent extends ComponentBase<ProjectLanguage> implements OnInit {

  public safetypointList: SafetyPointModelView[] = [];
  public debitorList: DebitorModel[] = [];
  public objektList: ObjektModelView[] = [];
  public objektfilteredList: ObjektModelView[] = [];
  public standortList: StandortModel[] = [];
  public standortfilteredList: StandortModel[] = [];
  public selectedObjekt: ObjektModelView = {};
  public selectedDebitor: DebitorModel = new DebitorModel();
  public selectedStandort: StandortModel = new StandortModel();

  public roofareaList: RoofareaModelView[] = [];
  public roofareafilteredList: RoofareaModelView[] = [];

  public SicherungssystemList: SicherungssystemModelView[] = [];
  public SicherungssystemfilteredList: SicherungssystemModelView[] = [];

  public selectedRoofarea: RoofareaModelView = { RoofareaID: 0, ObjektID: 0, Bezeichnung: "" };
  public selectedSicherungssystem: SicherungssystemModelView = { SicherungssystemID: 0, ObjektID: 0, Bezeichnung: "" };
  public selectedSafetyPoint: SafetyPointModelView | null = null;
  public enablecreatebutton: boolean = false;
  public currentMandant: Mandant = new Mandant();

  public withelectronicID: boolean = false;
  public withassetlink: boolean = true;
  public withgeolocation: boolean = false;
  public widthformular: boolean = false;

  public columnsdefMain: DbaDataTableColumn<SafetyPointModelView, ProjectLanguage>[] = [
    { id: 'Bezeichnung', label: 'Bezeichnung' },
    { id: 'Image', label: 'Bild', datatype: DbaMAtTableDatatypesEnum.DocumentImage, documentDataTypeID: DocumentDataType.SafetyPoint, documentDataIDProperty: 'SafetyPointId' },



    { id: 'Debitorname', label: 'debitor' },
    { id: 'StandortBezeichnung', label: 'Standort' },
    { id: 'ObjektBezeichnung', label: 'objekt' },
    { id: 'RoofareaBezeichnung', label: 'roofarea' },
    { id: 'SicherungssystemBezeichnung', label: 'Sicherungssystem' },
    { id: 'AssetLink', label: 'AssetLink' },
    { id: 'ElectronicId', label: 'ElectronicID' },
    { id: 'Longitude', label: 'Longitude', width: 100, datatype: DbaMAtTableDatatypesEnum.Number, format: '1.0-10' },
    { id: 'Latitude', label: 'Latitude', width: 100, datatype: DbaMAtTableDatatypesEnum.Number, format: '1.0-10' },
    { id: 'FormName', label: 'Formular' },

  ];
  constructor(
    public permissionService: ProjektPermissionService,
    private safetypointViewService: SafetyPointViewService,
    private safetypointService: SafetyPointService,
    private objektService: ObjektViewService,
    private debitorService: DebitorService,
    private roofareaService: RoofareaViewService,
    private standortService: StandortService,
    private sicherunssystenViewservice: SicherungssystemViewService,

    private safetyPointService: SafetyPointFormModelViewService,
    private completedFormDtoService: CompletedFormDtoService,
    private safetypointPDFService: SafetypointPDFService,
    public mandantService: MandantAuthService,
    private formViewService: FormViewService,
    private formDtoService: FormDtoService,
    private dialog: MatDialog,
  ) { super(); }

  public async ngOnInit() {
    await this.loadData();
  }

  private async loadData() {
    this.loading = true;

    await this.getDebitorList();
    await this.getStandortList();
    await this.getObjektList();
    await this.getRoofareaList();
    await this.getSicherungsList();
    await this.getSafetyPointList();

    this.loading = false;
  }

  public async getDebitorList() {
    try {
      var result = await Promise.all([this.debitorService.getList()]);
      this.debitorList = result[0].sort((a, b) =>
        (a.Name || '').localeCompare(b.Name || '')
      );
    } catch {
    }

    let alle: DebitorModel = new DebitorModel();
    alle.DebitorID = 0;
    alle.Name = "alle";
    this.debitorList.unshift(alle);
    this.selectedDebitor = this.debitorList[0];
  }

  public async getStandortList() {
    try {
      var result = await Promise.all([this.standortService.getList()]);
      this.standortList = result[0].sort((a, b) =>
        (a.Bezeichnung || '').localeCompare(b.Bezeichnung || '')
      );
    } catch {
    }

    let alle: StandortModel = new StandortModel();

    alle.StandortID = 0;
    alle.Bezeichnung = "alle";
    this.standortList.unshift(alle);
    this.selectedStandort = this.standortList[0];
    this.standortfilteredList = this.standortList;
  }

  public async getObjektList() {
    try {
      var result = await Promise.all([this.objektService.getList(), this.mandantService.GetCurrentMandant()]);
      this.currentMandant = result[1];
      this.objektList = result[0].sort((a, b) =>
        (a.Bezeichnung || '').localeCompare(b.Bezeichnung || '')
      );
    } catch {
    }

    let alle: ObjektModelView = {
      ObjektID: 0,
      Bezeichnung: "alle"
    };

    alle.ObjektID = 0;
    alle.Bezeichnung = "alle";
    this.objektList.unshift(alle);
    this.selectedObjekt = this.objektList[0];
    this.objektfilteredList = this.objektList;
  }

  public async getRoofareaList() {
    try {
      var result = await Promise.all([this.roofareaService.getList()]);
      this.roofareaList = result[0].sort((a, b) =>
        (a.Bezeichnung || '').localeCompare(b.Bezeichnung || '')
      );
    } catch {
    }
    var alle = new RoofareaModel();
    alle.RoofareaID = 0;
    alle.Bezeichnung = "alle";
    this.roofareaList.unshift(alle);
    this.roofareafilteredList = this.roofareaList;
    this.selectedRoofarea = this.roofareafilteredList[0];
  }
  public async getSafetyPointList() {
    try {
      var result = await Promise.all([this.safetypointViewService.getList()]);
      this.safetypointList = result[0];

    } catch {
    }
  }

  public async getSicherungsList() {
    let resultList = await Promise.all([
      this.sicherunssystenViewservice.getFilteredList(),
    ])
    this.SicherungssystemList = resultList[0];

    var alle: SicherungssystemModelView = {
      SicherungssystemID: 0,
      RoofareaID: 0,
      Bezeichnung: "alle"
    }

    this.SicherungssystemList.unshift(alle);
    this.SicherungssystemfilteredList = this.SicherungssystemList;
    this.selectedSicherungssystem = this.SicherungssystemfilteredList[0];
  }
  public async OpenDialog(data: DialogData<SafetyPointModelView>): Promise<void> {

    if (!this.permissionService.SafetyPointSchreiben) return;
    var safetypoint: SafetyPointModel = await firstValueFrom(this.dialog.open(CreateSafetyPointComponent, { data: data }).afterClosed());
    if (!safetypoint) return;

    var changedsafetypoint = await this.safetypointViewService.get(safetypoint.SafetyPointId);
    this.selectedSafetyPoint = null;
    if (data.mode == 'create') /*multipler input von Daten*/ {
      await this.loadData()
    }
    else if (data.mode == 'copy')
      this.safetypointList.push(changedsafetypoint);
    else if (data.mode == 'edit') {
      var index = this.safetypointList.findIndex(x => x.SafetyPointId == safetypoint.SafetyPointId);
      if (index != -1)
        this.safetypointList[index] = changedsafetypoint;
    }
    this.selectedSafetyPoint = changedsafetypoint;
  }

  public debitorFilter = (list: SafetyPointModelView[], filter: DebitorModel): SafetyPointModelView[] => {
    if (filter.DebitorID == undefined || filter.DebitorID == 0)
      return list;
    else
      return list.filter(x => x.DebitorID == filter.DebitorID);
  }

  public standortFilter = (list: SafetyPointModelView[], filter: StandortModel): SafetyPointModelView[] => {
    if (filter.StandortID == undefined || filter.StandortID == 0)
      return list;
    else
      return list.filter(x => x.StandortID == filter.StandortID);
  }

  public objektFilter = (list: SafetyPointModelView[], filter: ObjektModelView): SafetyPointModelView[] => {
    if (filter.ObjektID == undefined || filter.ObjektID == 0)
      return list;
    else
      return list.filter(x => x.ObjektID == filter.ObjektID);
  }

  public roofareaFilter = (list: SafetyPointModelView[], filter: RoofareaModelView): SafetyPointModelView[] => {
    if (filter.RoofareaID == undefined || filter.RoofareaID == 0)
      return list;
    else
      return list.filter(x => x.RoofareaId == filter.RoofareaID);
  }

  public sicherungssystemFilter = (list: SafetyPointModelView[], filter: SicherungssystemModelView): SafetyPointModelView[] => {
    if (filter.SicherungssystemID == undefined || filter.SicherungssystemID == 0)
      return list;
    else
      return list.filter(x => x.SicherungssystemID == filter.SicherungssystemID);
  }
  public filterStandort() {

    if (this.selectedDebitor?.DebitorID == 0) {
      this.standortfilteredList = this.standortList;
    }
    else {
      this.standortfilteredList = this.standortList.filter(x => x.DebitorID == this.selectedDebitor?.DebitorID || x.DebitorID == 0)
    }

    this.selectedStandort = this.standortfilteredList[0];
    this.selectedSicherungssystem = this.SicherungssystemfilteredList[0];
    this.filterObjekte();
  }

  public filterObjekte() {

    this.objektfilteredList = this.objektList;
    if (this.selectedDebitor?.DebitorID) {

      this.objektfilteredList = this.objektfilteredList.filter(x => x.DebitorID == this.selectedDebitor?.DebitorID || x.ObjektID == 0)
    }
    if (this.selectedStandort?.StandortID) {
      this.objektfilteredList = this.objektfilteredList.filter(x => x.StandortID == this.selectedStandort?.StandortID || x.ObjektID == 0)
    }
    this.filterroofarea();
  }
  public filterroofarea() {

    this.roofareafilteredList = this.roofareaList;
    if (this.selectedDebitor?.DebitorID) {

      this.roofareafilteredList = this.roofareafilteredList.filter(x => x.DebitorID == this.selectedDebitor?.DebitorID || x.RoofareaID == 0)
    }
    if (this.selectedStandort?.StandortID) {
      this.roofareafilteredList = this.roofareafilteredList.filter(x => x.StandortID == this.selectedStandort?.StandortID || x.RoofareaID == 0)
    }
    if (this.selectedObjekt?.ObjektID) {
      this.roofareafilteredList = this.roofareafilteredList.filter(x => x.ObjektID == this.selectedObjekt?.ObjektID || x.RoofareaID == 0)
    }

    this.filtersicherungssystem();
  }

  filtersicherungssystem() {

    this.SicherungssystemfilteredList = this.SicherungssystemList;
    if (this.selectedDebitor?.DebitorID) {

      this.SicherungssystemfilteredList = this.SicherungssystemfilteredList.filter(x => x.DebitorID == this.selectedDebitor?.DebitorID || x.SicherungssystemID == 0)
    }
    if (this.selectedStandort?.StandortID) {
      this.SicherungssystemfilteredList = this.SicherungssystemfilteredList.filter(x => x.StandortID == this.selectedStandort?.StandortID || x.SicherungssystemID == 0)
    }
    if (this.selectedObjekt?.ObjektID) {
      this.SicherungssystemfilteredList = this.SicherungssystemfilteredList.filter(x => x.ObjektID == this.selectedObjekt?.ObjektID || x.SicherungssystemID == 0)
    }
    if (this.selectedRoofarea?.RoofareaID) {
      this.SicherungssystemfilteredList = this.SicherungssystemfilteredList.filter(x => x.RoofareaID == this.selectedRoofarea?.RoofareaID || x.SicherungssystemID == 0)
    }
    this.selectedSicherungssystem = this.SicherungssystemfilteredList[0];
  }
  showAudits(selectedSafetyPoint: SafetyPointModelView) {
    this.dialog.open(SafetyPointFormComponent, {}).afterClosed().subscribe(() => {

    })
  }

  public async deleteData(value: SafetyPointModelView[]) {
    this.loading = true;
    await this.safetypointService.delete(value[0].SafetyPointId);
    await this.getSafetyPointList();
    this.loading = false;
  }

  public async Berichtdrucken(safetypoint: SafetyPointModelView) {
    this.loading = true;
    try {

      var safetypointformList = await this.safetyPointService.getFilteredList({ SafetyPointId: safetypoint.SafetyPointId })
      var forms = await this.formViewService.getList();

      var completdForms: CompletedFormDto[] = []
      var formfelderlist = []

      for (var m = 0; m < forms.length; m++) {
        var form = await this.formDtoService.get(forms[m].FormId);
        formfelderlist.push(form.StepList.flatMap(x => x.FieldList))
      }

      for (var i = 0; i < safetypointformList.length; i++) {
        var completedform = await this.completedFormDtoService.get(safetypointformList[i].CompletedFormId);
        completdForms.push(completedform)
      }
      formfelderlist = formfelderlist.flat();
      //this.loading = false;
      var result = await this.safetypointPDFService.generateAuditsPDF(safetypoint, safetypointformList, this.currentMandant, completdForms, formfelderlist);
      var downloadLink = window.document.createElement("a");
      var name = safetypoint.Bezeichnung.replaceAll(" ", "-")
      downloadLink.href = "data:application/pdf;base64," + result;
      downloadLink.download = 'audit_scherungspunkt' + name + '.pdf';
      downloadLink.click()

      this.loading = false;
    } catch {
      this.loading = false;
    } finally {
      this.loading = false;
    }
  }
}
